<template lang="pug">
  div.sort
    select
      option(disabled, selected) 排序
      each i in [1,2,3,4,5]
        option(value="#{i}")= i
    i.icon.iconfont.icon-sort-icon
</template>
<script>
export default {
  name: 'Sort'
}
</script>
<style lang = "scss" scoped>
.sort {
  border: 1px solid #e7e7ef;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1rem;
  color: #74747b;
  text-transform: uppercase;
  padding: 0.6rem;
  select {
    flex: 1;
    height: 100%;
    outline: none;
    border: none;
    background: transparent;
  }
  .icon {
    margin-right: 0.5em;
    font-size: 0.8rem;
  }
}
</style>
